export default function() {
  return (Math.random() - 0.5) * 1e-6;
}



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-force/src/jiggle.js
// module id = ../../../../d3-force/src/jiggle.js
// module chunks = 3